export default "__VITE_ASSET__a69af670__"